/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Ebook_EpubInputs */

const en_val_ebook_epub = /** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook (ePub)`)
};

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const es_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const fr_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const de_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const ja_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const zh_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const ar_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const id_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const it_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const ru_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const pt_val_ebook_epub = en_val_ebook_epub;

/** @type {(inputs: Val_Ebook_EpubInputs) => LocalizedString} */
const ko_val_ebook_epub = en_val_ebook_epub;

/**
* | output |
* | --- |
* | "eBook (ePub)" |
*
* @param {Val_Ebook_EpubInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_ebook_epub = /** @type {((inputs?: Val_Ebook_EpubInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Ebook_EpubInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_ebook_epub(inputs)
	if (locale === "es") return es_val_ebook_epub(inputs)
	if (locale === "fr") return fr_val_ebook_epub(inputs)
	if (locale === "de") return de_val_ebook_epub(inputs)
	if (locale === "ja") return ja_val_ebook_epub(inputs)
	if (locale === "zh") return zh_val_ebook_epub(inputs)
	if (locale === "ar") return ar_val_ebook_epub(inputs)
	if (locale === "id") return id_val_ebook_epub(inputs)
	if (locale === "it") return it_val_ebook_epub(inputs)
	if (locale === "ru") return ru_val_ebook_epub(inputs)
	if (locale === "pt") return pt_val_ebook_epub(inputs)
	return ko_val_ebook_epub(inputs)
});